import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="xmpiterator" id="xmpiterator"></a>
    <h1 {...{
      "id": "xmpiterator"
    }}>{`XMPIterator`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.2.0
Created by a call to `}<a parentName="p" {...{
        "href": "./XMPMeta.md#iteratoroptions-schemans-propname"
      }}>{`XMPMeta.iterator`}</a>{`. Walks recursively through the properties and qualifiers of an `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{`, and returns them as `}<a parentName="p" {...{
        "href": "./XMPIterator.md"
      }}>{`XMPProperty object`}</a>{`.`}</p>
    <p>{`The object has no JavaScript properties.  `}</p>
    <a name="xmpiterator-next" id="xmpiterator-next"></a>
    <h2 {...{
      "id": "next"
    }}>{`next()`}</h2>
    <p>{`Retrieves the next item in the metadata.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`XMPProperty`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`null`}</inlineCode>{`  `}</p>
    <a name="xmpiterator-skipsiblings" id="xmpiterator-skipsiblings"></a>
    <h2 {...{
      "id": "skipsiblings"
    }}>{`skipSiblings()`}</h2>
    <p>{`Skips the subtree below and the siblings of the current node on the subsequent call to next().`}</p>
    <a name="xmpiterator-skipsubtree" id="xmpiterator-skipsubtree"></a>
    <h2 {...{
      "id": "skipsubtree"
    }}>{`skipSubtree()`}</h2>
    <p>{`Skips the subtree below the current node on the subsequent call to next().`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      